import React from 'react'
import { Avatar, Stack, Box, Chip, alpha, Typography } from '@mui/material';

export default function SectionHeader({ step, icon, title, subtitle, action, BRAND}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{ mb: 1, width: "100%" }}
    >
      <Avatar
        variant="rounded"
        sx={{
          bgcolor: alpha(BRAND.main, 0.12),
          color: BRAND.main,
          width: 44,
          height: 44,
        }}
      >
        {icon}
      </Avatar>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {step != null && (
            <Chip
              label={`${step}`}
              size="small"
              sx={{
                bgcolor: BRAND.main,
                color: "#fff",
                fontWeight: 600,
                height: 22,
              }}
            />
          )}
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: BRAND.dark, lineHeight: 1.2 }}
          >
            {title}
          </Typography>
        </Stack>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action}
    </Stack>
  );
}
